"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminPageLayout = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
const Header_1 = require("../Header");
const Sidebar_1 = require("../Sidebar");
require("./index.scss");
const className = 'page';
const PageLayoutContent = (props) => {
    const { selectedLanguage, userBalance, userName, children, sidebarProps, onLanguageChange, showCharge, onConfirmCharge, } = props;
    return (react_1.default.createElement("div", { className: `${className}__container` },
        react_1.default.createElement("div", { className: `${className}__header` },
            react_1.default.createElement(Header_1.PageHeader, { onLanguageChange: onLanguageChange, selectedLanguage: selectedLanguage, userBalance: userBalance, userName: userName, showCharge: showCharge, onConfirmCharge: onConfirmCharge })),
        react_1.default.createElement("div", { className: `${className}__body` },
            react_1.default.createElement("div", { className: `${className}__sidebar` },
                react_1.default.createElement(Sidebar_1.PageSidebar, { ...sidebarProps })),
            react_1.default.createElement("div", { className: `${className}__content` }, children))));
};
const AdminPageLayout = (props) => {
    const { onLanguageChange, selectedLanguage, userBalance, userName, modificators, children, showCharge, onConfirmCharge, ...restProps } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement(PageLayoutContent, { onLanguageChange: onLanguageChange, selectedLanguage: selectedLanguage, userBalance: userBalance, userName: userName, sidebarProps: restProps, onConfirmCharge: onConfirmCharge, showCharge: showCharge }, children)));
};
exports.AdminPageLayout = AdminPageLayout;
//# sourceMappingURL=index.js.map